import React from 'react';
import { cn } from '@/lib/utils';
import { Icon } from 'venn-ui-kit';

interface StepHeaderProps {
  step: number;
  disabled?: boolean;
}

export const StepHeader = ({ step, disabled, children }: React.PropsWithChildren<StepHeaderProps>) => {
  return (
    <div className={cn('flex gap-[8px] text-[24px]')}>
      <Icon
        type={`circle-${step}`}
        className={cn({
          'text-venn-dark-blue': !disabled,
          'text-venn-grey-60': disabled,
        })}
      />
      <span className={cn({ 'text-venn-grey-80': disabled })}>{children}</span>
    </div>
  );
};
